import { allowUsesCookie } from '../common/CookieConsent';

export const sendToGA = (type: string, obj: any = null): void => {
  const w = window as any;
  if (w.ga) {
    w.ga('send', type, obj);
    w.ga('userViewId.send', type, obj);
  }
};

export const createGA = (id: string, customName: string = null): void => {
  const w = window as any;
  if (customName) {
    w.ga('create', id, { name: customName, cookieFlags: 'secure;samesite=none' });
  } else {
    w.ga('create', id, { cookieFlags: 'secure;samesite=none' });
  }
};

export const setGA = (key: string, value: string): void => {
  const w = window as any;
  w.ga('set', key, value);
};

export const startGA = (tour: any = null, loaded: boolean, cookie: boolean = null): void => {
  if (cookie === null) cookie = allowUsesCookie(tour?.hideCookie);
  if (!tour || !loaded || !cookie) return;
  const googleViewId = tour.client?.googleViewId || tour.user?.googleViewId;
  if (googleViewId) createGA(googleViewId, 'userViewId');
  createGA('UA-141667086-1'); // default treedis ga
  sendToGA('pageview');
};
